import { now } from '@internationalized/date';
import { ConfigData } from '@/types';
import { DEFAULT_CONFIG } from '@lib/defaultConfig';
import { resolveStoreTimeZone } from '@lib/storeDateTime';

export function cloneConfigBase(): ConfigData {
	return {
		...DEFAULT_CONFIG,
		specificPages: DEFAULT_CONFIG.specificPages.map((page) => ({ ...page })),
		categories: DEFAULT_CONFIG.categories.map((category) => ({ ...category })),
		products: DEFAULT_CONFIG.products.map((product) => ({ ...product })),
	};
}

export function buildCreateModeConfig(timezoneName: string | undefined): ConfigData {
	const storeTimeZone = resolveStoreTimeZone(timezoneName);
	const fromNow = now(storeTimeZone);

	return {
		...cloneConfigBase(),
		from_date: fromNow.toDate().toISOString(),
		to_date: fromNow.add({ days: 1 }).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate().toISOString(),
	};
}
